var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
class AggregatedError extends AggregateError {
  /**
 *
 *
 *
 *
 */
  constructor(errors, message) {
    super(errors, message);
    __publicField$1(this, "name", "AggregatedError");
    /**
 *
 */
    __publicField$1(this, "errors");
    this.errors = [...errors];
  }
}

const noop = (e) => e;

const $effect = Symbol("effect");
const $exec = Symbol("exec");
const $next = Symbol("next");
function fromAsync(value) {
  const res = value;
  res[$exec] = "async";
  res[$next] = (onSucceed, onFail) => fromAsync(res.then((r) => r[$next](onSucceed, onFail)));
  return res;
}

function succeed(value) {
  const res = [undefined, value];
  res[$exec] = "sync";
  res[$effect] = "right";
  res[$next] = (onSucceed = noop) => onSucceed(res);
  res.left = undefined;
  res.right = value;
  return res;
}
const some = succeed;
const right = succeed;
function succeedAsync(value) {
  return fromAsync(value.then(succeed));
}
function fail(error) {
  const res = [error, undefined];
  res[$exec] = "sync";
  res[$effect] = "left";
  res[$next] = (onSucceed, onFail = noop) => onFail(res);
  res.left = error;
  res.right = undefined;
  return res;
}
const none = () => fail(null);
const left = (value) => fail(value);
function failAsync(value) {
  return fromAsync(value.then(fail, fail));
}
const coerceFunction = (predicate) => typeof predicate !== "function" ? predicate : predicate();
function fromCondition(predicate, rightVal, leftVal) {
  return coerceFunction(predicate) ? succeed(coerceFunction(rightVal)) : fail(coerceFunction(leftVal));
}
function fromNullable(predicate) {
  const value = coerceFunction(predicate);
  return fromCondition(value !== null && value !== undefined, value, value);
}
function fromBoolean(predicate) {
  const value = coerceFunction(predicate);
  return fromCondition(value === true, value, value);
}
function invert(effect) {
  return effect[$next](
    (v) => fail(v[1]),
    (v) => succeed(v[0])
  );
}

function aggregateFailures(results, message) {
  const failed = results.filter((res) => res[$effect] === "left");
  return failed.length > 0 ? fail(
    new AggregatedError(
      failed.map(([error]) => error),
      message ?? "One or more effects failed to resolve"
    )
  ) : succeed(results.map(([, value]) => value));
}

function allSync(effects, options = {}) {
  return aggregateFailures(effects, options.message);
}
function allAsync(effects, options = {}) {
  return fromAsync(Promise.all(effects).then((v) => allSync(v, options)));
}

function catchError(handler) {
  const onFailure = (e) => handler(e.left);
  return (effect) => effect[$next](undefined, onFailure);
}
const catchFailure = catchError;
function catchErrorAsync(handler) {
  const onFailure = (e) => fromAsync(handler(e.left));
  return (effect) => effect[$next](undefined, onFailure);
}
function catchType(type, handler) {
  const onFailure = (e) => e.left instanceof type ? handler(e.left) : e;
  return (effect) => effect[$next](undefined, onFailure);
}
function catchTypeAsync(type, handler) {
  const onFailure = (e) => e.left instanceof type ? fromAsync(handler(e.left)) : e;
  return (effect) => effect[$next](undefined, onFailure);
}
function catchName(name, handler) {
  const onFailure = (e) => {
    const err = e.left;
    return typeof err === "object" && !!err && "name" in err && err.name === name ? handler(err) : e;
  };
  return (effect) => effect[$next](undefined, onFailure);
}
function catchNameAsync(name, handler) {
  const onFailure = (e) => {
    const err = e.left;
    return typeof err === "object" && !!err && "name" in err && err.name === name ? fromAsync(handler(err)) : e;
  };
  return (effect) => effect[$next](undefined, onFailure);
}
function catchSome(handler) {
  const onFailure = (e) => {
    const res = handler(e.left);
    return res[$effect] === "right" ? res[1] : e;
  };
  return (effect) => effect[$next](undefined, onFailure);
}

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, key + "" , value);
class UnknownError extends Error {
  constructor() {
    super(...arguments);
    /*                                                 */
    __publicField(this, "name", "UnknownError");
  }
}

function defaultMapError(error) {
  const message = error instanceof Error ? error.message : `${error}`;
  return new UnknownError(`try handler failed: ${message}`, { cause: error });
}

function fromExpression(effect) {
  return effect;
}
function syncImmediate(handler) {
  return succeed(handler());
}
function syncEffectImmediate(handler) {
  return handler();
}
function promiseImmediate(handler) {
  return succeedAsync(handler());
}
function promiseEffectImmediate(handler) {
  return fromAsync(handler());
}
function trySyncImmediate(handler, mapErr) {
  try {
    return succeed(handler());
  } catch (error) {
    return mapErr ? fail(mapErr(error)) : fail(defaultMapError(error));
  }
}
function tryPromiseImmediate(handler, mapErr) {
  return fromAsync(
    Promise.resolve().then(handler).then(
      succeed,
      (error) => mapErr ? fail(mapErr(error)) : fail(defaultMapError(error))
    )
  );
}

function sync(handler) {
  return function syncHandler(...a) {
    return succeed(handler.apply(this, a));
  };
}
function syncEffect(handler) {
  return handler;
}
function promise(handler) {
  return function promiseHandler(...a) {
    return succeedAsync(handler.apply(this, a));
  };
}
function promiseEffect(handler) {
  return function promiseEffectHandler(...a) {
    return fromAsync(handler.apply(this, a));
  };
}
function trySync(handler, mapErr) {
  return function trySyncHandler(...a) {
    return trySyncImmediate(() => handler.apply(this, a), mapErr);
  };
}
function tryPromise(handler, mapErr) {
  return function tryPromiseHandler(...a) {
    return tryPromiseImmediate(() => handler.apply(this, a), mapErr);
  };
}

function isRight(effect) {
  return effect[$effect] === "right";
}
const isSome = isRight;
const isSuccess = isRight;
function isLeft(effect) {
  return effect[$effect] === "left";
}
const isNone = isLeft;
const isFailure = isLeft;

function map(mapper) {
  const onSuccess = (e) => succeed(mapper(e[1]));
  return (effect) => effect[$next](onSuccess);
}
function mapAsync(mapper) {
  const onSuccess = (e) => succeedAsync(mapper(e[1]));
  return (effect) => effect[$next](onSuccess);
}
function mapSpread(mapper) {
  const onSuccess = (e) => succeed(mapper(...e[1]));
  return (effect) => effect[$next](onSuccess);
}
function mapAsyncSpread(mapper) {
  const onSuccess = (e) => succeedAsync(mapper(...e[1]));
  return (effect) => effect[$next](onSuccess);
}
function tryMap(mapper, mapErr) {
  const onSuccess = trySync((e) => mapper(e[1]), mapErr);
  return (effect) => effect[$next](onSuccess);
}
function tryMapSpread(mapper, mapErr) {
  const onSuccess = trySync((e) => mapper(...e[1]), mapErr);
  return (effect) => effect[$next](onSuccess);
}
function tryMapAsync(mapper, mapErr) {
  const onSuccess = tryPromise((e) => mapper(e[1]), mapErr);
  return (effect) => effect[$next](onSuccess);
}
function tryMapAsyncSpread(mapper, mapErr) {
  const onSuccess = tryPromise((e) => mapper(...e[1]), mapErr);
  return (effect) => effect[$next](onSuccess);
}
function flatMap(mapper) {
  const onSuccess = (e) => mapper(e[1]);
  return (effect) => effect[$next](onSuccess);
}
function flatMapSpread(mapper) {
  const onSuccess = (e) => mapper(...e[1]);
  return (effect) => effect[$next](onSuccess);
}
function mapError(mapper) {
  return (effect) => effect[$next](undefined, (e) => fail(mapper(e.left)));
}
function mapErrorAsync(mapper) {
  return (effect) => effect[$next](undefined, (e) => failAsync(mapper(e.left)));
}

function pipe(...args) {
  switch (args.length) {
    case 2:
      return args[1](args[0]);
    case 3:
      return args[2](args[1](args[0]));
    case 4:
      return args[3](args[2](args[1](args[0])));
    case 5:
      return args[4](args[3](args[2](args[1](args[0]))));
    case 6:
      return args[5](args[4](args[3](args[2](args[1](args[0])))));
    case 7:
      return args[6](args[5](args[4](args[3](args[2](args[1](args[0]))))));
    case 8:
      return args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0])))))));
    case 9:
      return args[8](args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0]))))))));
    case 10:
      return args[9](args[8](args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0])))))))));
    case 1:
      return args[0];
    case 0:
      return undefined;
    default:
      return args.slice(1).reduce((acc, fn) => fn(acc), args[0]);
  }
}

function mapIf({
  onTrue,
  onFalse
}) {
  return (effect) => effect[$next]((e) => e[1] ? onTrue() : onFalse());
}
function ifImmediate(condition, {
  onTrue,
  onFalse
}) {
  return mapIf({ onTrue, onFalse })(succeed(condition));
}
function ifEffect(condition, handler) {
  return () => ifImmediate(condition, handler);
}
function when(predicate) {
  const onSucceed = (e) => succeed(predicate(e[1]) ? some(e[1]) : none());
  return (effect) => effect[$next](onSucceed);
}
function whenEffect(predicate) {
  const onSucceed = (e) => {
    return pipe(
      predicate(e[1]),
      map((p) => p ? succeed(e[1]) : fail(undefined))
    );
  };
  return (effect) => effect[$next](onSucceed);
}
function unless(predicate) {
  const onSucceed = (e) => succeed(predicate(e[1]) ? fail(undefined) : succeed(e[1]));
  return (effect) => effect[$next](onSucceed);
}

function match(param) {
  const onSucceedWrapper = (e) => succeed(param.onSucceed(e[1]));
  const onFailWrapper = (e) => succeed(param.onFail(e[0]));
  return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}
function matchAsync(param) {
  const onSucceedWrapper = (e) => succeedAsync(param.onSucceed(e[1]));
  const onFailWrapper = (e) => succeedAsync(param.onFail(e[0]));
  return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}
function matchEffect(param) {
  const onSucceedWrapper = (e) => param.onSucceed(e[1]);
  const onFailWrapper = (e) => param.onFail(e[0]);
  return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}

function policy(options) {
  if (Object.values(options).every((v) => v === undefined)) {
    throw new Error("You must provide at least one option to the policy function");
  }
  const { times = 0, delay = 0 } = options;
  let currentRetry = 0;
  const until = options.until ?? (() => times && currentRetry >= times);
  return (failure) => {
    currentRetry += 1;
    return until(failure[0]) ? failure : succeedAsync(
      new Promise((r) => {
        if (delay) {
          setTimeout(() => r(true), delay);
          return;
        }
        r(true);
      })
    );
  };
}
function retry(task, retryPolicy) {
  const retrier = async (args) => {
    while (true) {
      const res = await task(...args);
      if (isSuccess(res)) {
        return res;
      }
      const policyRes = await retryPolicy(res);
      if (isFailure(policyRes)) {
        return policyRes;
      }
    }
  };
  return (...args) => fromAsync(retrier(args));
}

function tap(handler) {
  const onSucceed = (e) => (handler(e[1]), e);
  return (effect) => effect[$next](onSucceed);
}
function tapSpread(handler) {
  const onSucceed = (e) => (handler(...e[1]), e);
  return (effect) => effect[$next](onSucceed);
}
function tapAsync(handler) {
  const onSucceed = (e) => fromAsync(handler(e[1]).then(() => e));
  return (effect) => effect[$next](onSucceed);
}
function tapAsyncSpread(handler) {
  const onSucceed = (e) => fromAsync(handler(...e[1]).then(() => e));
  return (effect) => effect[$next](onSucceed);
}
function tapError(handler) {
  const onFail = (e) => (handler(e[0]), e);
  return (effect) => effect[$next](undefined, onFail);
}
function tapErrorAsync(handler) {
  const onFail = (e) => fromAsync(handler(e[0]).then(() => e));
  return (effect) => effect[$next](undefined, onFail);
}

function unbox(unboxer = (_) => _) {
  return (effect) => effect[$exec] === "async" ? effect.then((e) => unboxer(e[0] ?? e[1])) : unboxer(effect[0] ?? effect[1]);
}
function unboxThrow(unboxer = (_) => _) {
  const valueOrThrow = (effect) => {
    if (effect[0]) {
      throw effect[0];
    }
    return unboxer(effect[1]);
  };
  return (effect) => effect[$exec] === "async" ? effect.then(valueOrThrow) : valueOrThrow(effect);
}

export { AggregatedError, UnknownError, allAsync, allSync, catchError, catchErrorAsync, catchFailure, catchName, catchNameAsync, catchSome, catchType, catchTypeAsync, fail, failAsync, flatMap, flatMapSpread, fromBoolean, fromCondition, fromExpression, fromNullable, ifEffect, ifImmediate, invert, isFailure, isLeft, isNone, isRight, isSome, isSuccess, left, map, mapAsync, mapAsyncSpread, mapError, mapErrorAsync, mapIf, mapSpread, match, matchAsync, matchEffect, none, pipe, policy, promise, promiseEffect, promiseEffectImmediate, promiseImmediate, retry, right, some, succeed, succeedAsync, sync, syncEffect, syncEffectImmediate, syncImmediate, tap, tapAsync, tapAsyncSpread, tapError, tapErrorAsync, tapSpread, tryMap, tryMapAsync, tryMapAsyncSpread, tryMapSpread, tryPromise, tryPromiseImmediate, trySync, trySyncImmediate, unbox, unboxThrow, unless, when, whenEffect };
/*                              */
